// src/components/wellfinder/holderFeatures.js
//
// Kept out of ReviewMap.jsx so that file exports only its component (fast
// refresh), and so the features can be tested without a map.

const EMPTY_FC = { type: "FeatureCollection", features: [] };

/**
 * The holding detection and its line to the well it holds, or an empty
 * collection. `holder` is { lon, lat, wellLon, wellLat } — the holder's
 * effective point and the registry point of the taken candidate.
 */
export function holderFeatures(holder) {
  if (holder?.lon == null || holder?.lat == null) return EMPTY_FC;
  const at = [holder.lon, holder.lat];
  const features = [
    { type: "Feature", geometry: { type: "Point", coordinates: at }, properties: { part: "point" } },
  ];
  if (holder.wellLon != null && holder.wellLat != null) {
    features.push({
      type: "Feature",
      geometry: { type: "LineString", coordinates: [at, [holder.wellLon, holder.wellLat]] },
      properties: { part: "link" },
    });
  }
  return { type: "FeatureCollection", features };
}
